import React from 'react';

export enum EContextEvent {
  MODAL = 'useModal',
  ADDTOCART = 'addToCart',
}

export interface IModalContext {
  type: string;
  modalProps?: any;
  compProps?: any;
  onClose?: () => void;
  children?: any;
  basePageData?: any;
}

export interface IAddToCartContext {
  useSpinner: boolean;
  goto: string;
  service: string;
  items: {
    itemsList: any[];
    serviceContext: any;
    shoppingContext: any;
  }[];
  autoPay?: boolean;
}
export interface IEventsContext {
  dispatchFactory?: (data: {
    event: any;
    type: EContextEvent;
    data: any;
  }) => Promise<{ success: boolean; message?: string } | undefined>;
  impression?: (data: any) => void;
  addToCart?: (data: IAddToCartContext) => Promise<{
    success: boolean;
    message?: string;
  }>;
  button?: {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  };
  link?: {
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  };
  modal?: {
    // THIS SHOULD BE DEPRECATED, USE setModal instead...
    modType: string;
    setType: (modalType: string) => void;
  };
  setModal?: (data: IModalContext) => void;
}

export const EventContext = React.createContext<IEventsContext>({});
export const useEventContext = () => {
  return React.useContext(EventContext);
};
